import { withRouter, Link } from 'react-router-dom';
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import { types } from 'mobx-state-tree';
import {
  Button
} from 'react-bootstrap';
import LoggedinUser from '../../models/LoggedinUser';
import ListErrors from '../../components/ListErrors';
import Footer from '../../components/footer/Footer';
import Close from '@material-ui/icons/Close';

// css
const nodatafound = require('./nodatafound.css');


interface Props {
  loggedinUser: typeof LoggedinUser.Type;
}

@observer
export default class NoDataFound extends React.Component<{ loggedinUser: typeof LoggedinUser.Type }> {

  handleClose = () => {
    this.setState({ anchorEl: null });
  }

  onClickLogOut = (e) => { this.props.loggedinUser.logout(); this.handleClose(); };

  render() {
    const errors: string = this.props.loggedinUser.properties.errors;

    const callTo: string = 'tel:';
    const noDataPhonenumber: string = callTo.concat(this.props.loggedinUser.branding.fullPhoneNumber);

    const mailTo: string = 'mailto:';
    const noDataMailadress: string = mailTo.concat(this.props.loggedinUser.branding.mailAddress);

    const imageStyle = {
      width: '100%',
      height: 'auto',
      background: 'cover'
    };

    const astyle = {
      color: '#F24962',
    };

    // images
    const branding = 'advoco'; //always branding 'advoco'
    const imgNoDataFound = require('../../images/branding/' + branding + '/loginAndNotSubscriber_bg.jpg');
    const imgLogInStar = require('../../images/star32x32.png');


    // We need to check that we allows Urls (when inApp Browser we do not allow Urls):
    const allowUrls = this.props.loggedinUser.view.allowUrls;
    //contactUs with or without Url    
    const contactUs = allowUrls ? (
      <div>Maila <a href={noDataMailadress} style={astyle}>{this.props.loggedinUser.branding.mailAddress}</a> eller ring <a href={noDataPhonenumber} style={astyle}>{this.props.loggedinUser.branding.displayPhoneNumber}</a></div>
    ) : (
        <div>Maila <span style={astyle}>{this.props.loggedinUser.branding.mailAddress}</span> eller ring <span style={astyle}>{this.props.loggedinUser.branding.displayPhoneNumber}</span></div>
      );

    return (
      <div className="container page">
        <div className="row">
          <div className="nodatafound_login-imgdiv">
            <div className="nodatafound-image">
              <div className="nodatafound_close_icon_upper_right"><Close onClick={this.onClickLogOut} style={{ visibility: this.props.loggedinUser.view.showNoDataFoundCloseIcon ? 'visible' : 'hidden' }} /></div>
              <img src={imgNoDataFound} style={imageStyle} alt="NoDataFound" />
            </div>
            <div className="grid-div">
              <div className="nodatafound_login_grid">
                <div className="nodatafound_login_header_box">
                  <div>Hej {this.props.loggedinUser.firstName}!</div>
                </div>
                <div className="nodatafound_login_forgotPassword_surf_box">
                  <div>Just nu har vi problem med att</div>
                  <div>hämta data för ditt abonnemang.</div>
                  <div>Försök igen lite senare.</div>
                </div>
              </div>
            </div>
          </div>
          <div className="nodatafound_features_grid">
            <div className="nodatafound_features_headline_box">
              <h3 className="nodatafound_features_headline">Behöver du hjälp?</h3>
              <h4 className="nodatafound_features_headline_2">Hör av dig till oss.</h4>
            </div>
            <div className="nodatafound_features_smaller_headline_box">
              {/* <div>Maila <a href={noDataMailadress} style={astyle}>{this.props.loggedinUser.branding.mailAddress}</a> eller ring <a href={noDataPhonenumber} style={astyle}>{this.props.loggedinUser.branding.displayPhoneNumber}</a></div> */}
              {contactUs}
            </div>
          </div>
          <div className="footerDiv">
            <Footer loggedinUser={this.props.loggedinUser} />
          </div>
        </div>
      </div >
    );
  }
}



// WEBPACK FOOTER //
// ./src/pages/nodatafound/NoDataFound.tsx